module.exports = __webpack_public_path__ + "static/logo-ca618989c5c26561563f5547cbd69ad6.svg";